// @ts-check

import React, { useState } from "react";
import { Badge, Button, Card, EmptySearchResult, IndexFilters, IndexFiltersMode, IndexTable, Text } from "@shopify/polaris";
import { PageDownIcon } from "@shopify/polaris-icons";
import { format } from "date-fns";

import { LockableCard } from "components/cards/LockableCard/LockableCard";

import { useGlobalContext } from "context/GlobalContext";

export const OrderExportsTable = () => {
  const { orderExports, orderExportsLocked, isRefetchingOrderExports } = useGlobalContext();
  const [tabIndex, setTabIndex] = useState(0);

  const emptyStateMarkup = (
    <EmptySearchResult
      title="No order exports"
      withIllustration
    />
  );

  const tabs = [
    {
      content: "All",
      index: 0,
      onAction: () => setTabIndex(0),
      id: "all",
    },
  ];

  const rowMarkup = orderExports.map(({ id, created_at, status, download_url }, index) => {
    let badge;
    if (status === "ERROR") {
      badge = (
        <Badge tone="critical">Error</Badge>
      );
    } else if (status === "IN_PROGRESS") {
      badge = (
        <Badge progress="partiallyComplete" tone="info">
          In progress
        </Badge>
      );
    } else if (status === "PENDING") {
      badge = (
        <Badge progress="incomplete" tone="attention">
          Pending
        </Badge>
      );
    } else if (status === "DONE" && download_url) {
      badge = (
        <Button variant="secondary" icon={PageDownIcon} url={download_url} download>Download</Button>
      );
    }

    return (
      <IndexTable.Row
        id={id}
        key={id}
        position={index}
      >
        <IndexTable.Cell>
          <Text variant="bodyMd" fontWeight="bold" as="span">
            {format(new Date(created_at), "yyyy-MM-dd hh:mmbbb")}
          </Text>
        </IndexTable.Cell>
        <IndexTable.Cell>{badge}</IndexTable.Cell>
      </IndexTable.Row>
    )
  });

  return (
    <LockableCard locked={orderExportsLocked} lockedDescription="You need to upgrade to the Pro plan to access this feature">
      <Card padding="0">
        <IndexFilters
          onQueryChange={() => null}
          onQueryClear={() => null}
          onClearAll={() => null}
          tabs={tabs}
          selected={tabIndex}
          loading={isRefetchingOrderExports}
          mode={IndexFiltersMode.Default}
          setMode={() => null}
          filters={[]}
          canCreateNewView={false}
        />
        <IndexTable
          resourceName={{
            singular: "order export",
            plural: "order exports",
          }}
          itemCount={orderExports.length}
          headings={[
            { title: "Created at" },
            { title: "Status" },
          ]}
          selectable={false}
          emptyState={emptyStateMarkup}
        >
          {rowMarkup}
        </IndexTable>
      </Card>
    </LockableCard>
  )
};
